import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconMessageSvg } from "./IconMessageSvg.mjs";
const IconMessage = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconMessageSvg, ...svgProps }) });
export {
  IconMessage
};
